module.exports = __webpack_public_path__ + "media/images/emblems/Cheseaux-Noreaz-coat_of_arms-9053fe95cc95cdda98a5f458ffb620c9.svg";